export interface RedeCompartilhamento {
  id: string;
  rotulo: string;
  icone: string;
  cor: string;
  url: string;
}

interface RedeConhecida {
  rotulo: string;
  icone: string;
  cor: string;
  montar: (url: string, titulo: string) => string;
}

const REDES_CONHECIDAS: Record<string, RedeConhecida> = {
  facebook: {
    rotulo: 'Compartilhar no Facebook',
    icone: 'fa-brands fa-facebook-f',
    cor: '#1877F2',
    montar: (url) => `https://www.facebook.com/sharer/sharer.php?u=${url}`,
  },
  x: {
    rotulo: 'Compartilhar no X',
    icone: 'fa-brands fa-x-twitter',
    cor: '#1DA1F2',
    montar: (url, titulo) => `https://twitter.com/intent/tweet?url=${url}&text=${titulo}`,
  },
  whatsapp: {
    rotulo: 'Compartilhar no WhatsApp',
    icone: 'fa-brands fa-whatsapp',
    cor: '#25D366',
    montar: (url, titulo) => `https://api.whatsapp.com/send?text=${titulo}%20${url}`,
  },
  linkedin: {
    rotulo: 'Compartilhar no LinkedIn',
    icone: 'fa-brands fa-linkedin-in',
    cor: '#0A66C2',
    montar: (url) => `https://www.linkedin.com/sharing/share-offsite/?url=${url}`,
  },
  telegram: {
    rotulo: 'Compartilhar no Telegram',
    icone: 'fa-brands fa-telegram',
    cor: '#229ED9',
    montar: (url, titulo) => `https://t.me/share/url?url=${url}&text=${titulo}`,
  },
  email: {
    rotulo: 'Compartilhar por e-mail',
    icone: 'fa-solid fa-envelope',
    cor: '#6B7280',
    montar: (url, titulo) => `mailto:?subject=${titulo}&body=${url}`,
  },
};

/** "X (Twitter)", "twitter" e "x" são a mesma rede; "E-mail" e "email" também. */
const SINONIMOS: Record<string, string> = {
  twitter: 'x',
  xtwitter: 'x',
  mail: 'email',
};

function chave(nome: string): string {
  const limpo = nome
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '');

  return SINONIMOS[limpo] ?? limpo;
}

/**
 * Os botões de compartilhamento a partir das redes que o adm escolheu, na ordem dele. Rede
 * com URL própria usa a URL; rede reconhecida sem URL usa o compartilhamento padrão dela; rede
 * desconhecida sem URL não tem para onde levar e fica de fora.
 *
 * `endereco` e `titulo` chegam crus e são codificados aqui.
 */
export function redesDeCompartilhamento(
  redes: readonly { nome: string; url: string | null }[],
  endereco: string,
  titulo: string,
): RedeCompartilhamento[] {
  const url = encodeURIComponent(endereco);
  const tituloCodificado = encodeURIComponent(titulo);

  return redes.flatMap((rede, indice) => {
    const conhecida = REDES_CONHECIDAS[chave(rede.nome)];
    const destino = rede.url?.trim() || conhecida?.montar(url, tituloCodificado);

    if (!destino) return [];

    return [
      {
        id: `${chave(rede.nome) || 'rede'}-${indice}`,
        rotulo: conhecida?.rotulo ?? `Compartilhar em ${rede.nome}`,
        icone: conhecida?.icone ?? 'fa-solid fa-link',
        cor: conhecida?.cor ?? 'var(--primary-color)',
        url: destino,
      },
    ];
  });
}
